export default {
  links: {},
  organizations: [],
  organization: {
    workspaces: [],
  },
  workspaces: [],
  user: {},
};
